import GwpBuyStack from '@/components/buy-stack/gwp-buy-stack/GwpBuyStack';
import '@/components/buy-stack/gwp-buy-stack/GwpGiftModalRegister';
import '@/components/buy-stack/gwp-buy-stack/GwpImageCarouselRegister';
import {
  gwpBundleSchema,
  GwpVariant,
  gwpVariantSchema,
} from '@/components/buy-stack/gwp-buy-stack/types';
import {safeParseOrElse} from '@/utilities/safe-parse-or-else';
import {Signal} from '@preact/signals';
import {VNode} from 'preact';
import register from 'preact-custom-element';
import {z} from 'zod';

type LoaderProps = {
  bundles: string;
  variants: string;
  children: VNode;
  selectedVariant: Signal<GwpVariant | null>;
};

const parseVariantsJson = (json: string) =>
  safeParseOrElse(
    z.array(z.array(gwpVariantSchema).nullable()),
    [],
    JSON.parse(json)
  )
    .filter(Boolean)
    .flat() as GwpVariant[];

function Loader({bundles, variants, selectedVariant, ...rest}: LoaderProps) {
  return (
    <GwpBuyStack
      bundles={safeParseOrElse(
        // @ts-expect-error Zod casts string to number in price.amount
        z.array(gwpBundleSchema),
        [],
        JSON.parse(bundles)
      )}
      variants={parseVariantsJson(variants)}
      onUpdateSelectedVariant={(v) => (selectedVariant.value = v)}
      {...rest}
    />
  );
}

export function registerGwpBuyStack(
  selectedVariant: LoaderProps['selectedVariant']
) {
  register(
    (props: Omit<LoaderProps, 'selectedVariant'>) => (
      <Loader {...props} selectedVariant={selectedVariant} />
    ),
    'gwp-buy-stack'
  );
}
